// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3vlbr","footer":"ReportModalFilter_footer__1qsn-"};